export enum JobTaskTableFields {
    STATUS = 'status',
    SUB_TYPE = 'subType',
    // Value stays 'workflowName', not 'workflowId': column-body-renderer.tsx uses this
    // string directly as a property key to read the display name off each row. Filtering
    // on this field still targets the API's workflowId, via FIELD_MAPPING in mappers/constants.ts.
    WORKFLOW_ID = 'workflowName',
    ELAPSED = 'elapsed',
    START_TIME = 'startTime',
    END_TIME = 'endTime',
    TASK_DESCRIPTION = 'taskDescription',
    PROJECT = 'project',
    JOB_ID = 'jobId',
    TASK_SUMMARY = 'taskSummary',
    TASK_NAME = 'taskName',
    PARENT_ID = 'parentId',
}

export enum SubTypeField {
    JOB_ROOT = 'root',
    JOB_CHILD = 'child',
    TASK_MANUAL = 'manual',
    TASK_AUTOMATIC = 'automatic',
    TASK_OPERATION = 'operation',
}
